import { apiFetch, readApiError } from "../api/api-client";

export type DeviceModelDefinition = {
  blockPrefix: string;
  displayName: string;
  id: string;
  url: string;
};

export async function fetchDeviceModels(signal?: AbortSignal) {
  const response = await apiFetch("/api/device-models", { cache: "no-store", signal });
  if (!response.ok) {
    throw new Error(await readApiError(response, "设备模型目录读取失败"));
  }

  const data: unknown = await response.json();
  if (!Array.isArray(data) || !data.every(isDeviceModelDefinition)) {
    throw new Error("设备模型目录返回了无效数据");
  }
  return data;
}

export function matchDeviceBlockPrefix(blockName: string, blockPrefixes: readonly string[]) {
  return [...blockPrefixes]
    .sort((left, right) => right.length - left.length)
    .find((blockPrefix) => blockName.startsWith(blockPrefix));
}

export function getDeviceModelsForPrefix(
  models: readonly DeviceModelDefinition[],
  blockPrefix: string
) {
  return models.filter((model) => model.blockPrefix === blockPrefix);
}

function isDeviceModelDefinition(value: unknown): value is DeviceModelDefinition {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const candidate = value as Record<string, unknown>;
  return (
    typeof candidate.id === "string" &&
    typeof candidate.blockPrefix === "string" &&
    typeof candidate.displayName === "string" &&
    typeof candidate.url === "string"
  );
}
